import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  FormControl,
  FormLabel,
  Stack,
} from '@chakra-ui/react';
import { toast } from 'react-toastify';
import { useUpdateSlackIdMutation } from '../../features/apis/authApi';

interface SlackModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  name?: string;
  user_id?: string;
  email?: string;
}

const SlackModal: React.FC<SlackModalProps> = ({
  isOpen,
  setIsOpen,
  user_id,
  name,
  email,
}) => {
  const [slackId, setSlackId] = useState('');
  const [loading, setLoading] = useState(false);
  const [updateSlackId] = useUpdateSlackIdMutation();

  const onClose = () => {
    setIsOpen(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSlackId(e.target.value);
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await updateSlackId({
        slack_id: slackId,
        employee_id: user_id || '',
      });

      if ('data' in response) {
        toast.success(response.data.message);
        onClose();
      } else {
        toast.error('Failed to update Slack ID');
      }
    } catch (error) {
      console.error('Error updating Slack ID:', error);
      toast.error('Failed to update Slack ID');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.200" backdropFilter="blur(4px)" />{' '}
      <ModalContent mx={4}>
        <ModalHeader>Slack Modal</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing={4}>
            <FormControl>
              <FormLabel fontSize="12px" fontWeight="bold">
                Slack ID of {name ? name : email}
              </FormLabel>
              <Input
                type="text"
                placeholder="Enter Slack ID..."
                value={slackId}
                onChange={handleChange}
                fontSize="11px"
                border="0.5px solid"
                borderColor="#D4D4D4"
                _focus={{ borderColor: '#D4D4D4', boxShadow: 'none' }}
                _hover={{ borderColor: '#D4D4D4' }}
              />
            </FormControl>
          </Stack>
        </ModalBody>

        <ModalFooter>
          <Button
            bgGradient="linear(to-r, #6535EB, #9F3198)"
            _hover={{
              bgGradient: 'linear(to-r, #7F4FF0, #B85AAE)',
            }}
            color="white"
            onClick={handleSubmit}
            isLoading={loading}
            disabled={!slackId.trim()}
          >
            {loading ? 'Adding Slack...' : 'Add Slack'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SlackModal;
